import { render, staticRenderFns } from "./logwood-history-date.vue?vue&type=template&id=0802f215&scoped=true&"
import script from "./logwood-history-date.vue?vue&type=script&lang=ts&"
export * from "./logwood-history-date.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0802f215",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0802f215')) {
      api.createRecord('0802f215', component.options)
    } else {
      api.reload('0802f215', component.options)
    }
    module.hot.accept("./logwood-history-date.vue?vue&type=template&id=0802f215&scoped=true&", function () {
      api.rerender('0802f215', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/logwood/components/logwood-history-date.vue"
export default component.exports